import StandardDocServer from './StandardDocServer';

export default function useDocServer() {
  return StandardDocServer.getInstance();
}
